import { defineStore } from 'pinia';
import type { FormMode } from '@/help/types';

export const useHelpStore = defineStore('help', {
  state: () => ({
    showHelpDrawer: false,
    loading: false,
    formMode: '',
  }),
  actions: {
    toggleDrawer() {
      this.showHelpDrawer = !this.showHelpDrawer;
    },
    openDrawer() {
      this.showHelpDrawer = true;
    },
    closeDrawer() {
      this.showHelpDrawer = false;
    },
    changeFormMode(formMode: FormMode) {
      this.formMode = formMode;
    },
  },
});
